import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

// Keep these in sync with the FAQPage JSON-LD in public/index.html
const faqs = [
  {
    question: 'How do I copy text from an image or screenshot on Mac?',
    answer:
      'With Ghost Text installed, press the global shortcut (⌘⇧2) or click Capture Text in the menu bar, drag over the text in the image or screenshot, and it is recognized and copied to your clipboard instantly. Paste it anywhere with ⌘V.',
  },
  {
    question: 'Does Ghost Text send my screen data anywhere?',
    answer:
      "No. All OCR runs locally on your Mac using Apple's built-in Vision framework. Ghost Text works 100% offline and your screen content never leaves your device.",
  },
  {
    question: 'What can Ghost Text extract text from?',
    answer:
      'Anything rendered on your screen: screenshots, images, paused videos, locked PDFs, error dialogs, remote desktop sessions, and apps that block text selection. You can also drag and drop image files onto the app to extract their text.',
  },
  {
    question: 'Is Ghost Text a subscription?',
    answer:
      'No. Ghost Text is a one-time purchase of $9.99 with lifetime access, all features included, and free updates forever. No account is required.',
  },
  {
    question: 'Is there a free trial?',
    answer:
      'Yes. You can download the Ghost Text free trial for macOS directly from this site and try it before buying.',
  },
  {
    question: 'How is Ghost Text different from macOS Live Text?',
    answer:
      "Live Text works only inside supported apps like Photos, Safari, and Preview. Ghost Text captures text from anywhere on the screen — video frames, dialogs, remote desktops, and apps Live Text can't reach — with a global shortcut, automatic clipboard copy, and capture history.",
  },
];

const FAQ = () => {
  const headerRef = useScrollAnimation();
  const listRef = useScrollAnimation();

  return (
    <section id="faq" className="relative py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div ref={headerRef} className="text-center mb-12 animate-slide-up">
          <span className="eyebrow">FAQ</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-bone mt-4 mb-5">
            Questions, answered
          </h2>
        </div>

        {/* Q&A list — plain HTML details for crawlability and accessibility */}
        <div ref={listRef} className="space-y-3 animate-slide-up">
          {faqs.map((faq) => (
            <details key={faq.question} className="card-capture group px-6 py-1">
              <summary className="cursor-pointer list-none flex items-center justify-between gap-4 py-4">
                <h3 className="font-display text-base lg:text-lg font-semibold text-bone">
                  {faq.question}
                </h3>
                <span
                  aria-hidden="true"
                  className="font-mono text-phantom text-lg transition-transform duration-200 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <p className="text-mist leading-relaxed pb-5 pr-8">
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
